
import * as jotoTypes from "../api/joto-types";
import * as env from "../env";
import queryString from "query-string";
import * as log from 'loglevel';

// log.setDefaultLevel(log.levels.DEBUG);
const logger = log.getLogger('JotoUIUtils.tsx');
logger.setLevel(env.logLevel);

export type UserMessage = null | string | Error;
export type ValidationMessage = undefined | string;

export const sleep = (ms: number) => new Promise<string>(resolve => setTimeout(() => resolve('sleep-timeout'), ms));

type MessageType = string | ((a : any) => string);

function validateRegexMatch(message : MessageType, value : string | null, regex: RegExp) : ValidationMessage {
    if((value != null)){
        logger.trace(value);
        if (value.match(regex)){
            return undefined; //TODO 
        }
    }
    if(typeof message === 'string') {
        return message;
    } else {
        return message(value);
    }
}

// /^[a-zA-Z0-9 ÄäÖöÜüß\-_.,:;?"+*%!$()=]*$/
const textRegexString = 'a-zA-Z0-9 ÄäÖöÜüß\\-_.,:;?"+*%!$()=';
const textRegex = new RegExp('^[' + textRegexString + ']*$');

const validateTextField = (message : MessageType, value : string | null, maxLength: number) : ValidationMessage => {
    const regex = textRegex;
    const v1 = validateRegexMatch(message, value, regex);
    logger.trace(`value && value.length < maxLength : ${JSON.stringify(value)} , ${maxLength}`)
    const v2 = (typeof value === 'string' && value.length < maxLength) ? undefined : `Der Eingabewert ist zu lang: ${value && value.length} > ${maxLength}`;
    return v1 || v2;
}

const shortTextMaxLength = 100;
const validateShortTextField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    return validateTextField(message, value, shortTextMaxLength);
};

const mediumTextMaxLength = 500;
const validateMediumTextField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    return validateTextField(message, value, mediumTextMaxLength);
};

const longTextMaxLength = 2000;
const validateLongTextField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    return validateTextField(message, value, longTextMaxLength);
};

const validateNumberTextField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    const regex = /^[0-9]*$/;
    return validateRegexMatch(message, value, regex);
};

const validateGermanZipTextField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    const regex = /^([0-9]{5}|)$/;
    return validateRegexMatch(message, value, regex);
};

const validateURLField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    let URLRegEx = /^(http(s?):\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*((0-9)*)*(\/?)([a-zA-Z0-9\-.?,'/\\+&=%$#_]*)?)?$/;
    // URLRegEx = /^.*$/;
    return validateRegexMatch(message, value, URLRegEx);
};

const validateforProfitField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    const regex = /^(yes|no)*$/;
    return validateRegexMatch(message, value, regex);
};
const validateStateField = (message : MessageType) => (value : string | null) : ValidationMessage => {
    const regex = /^[1-3]$/;
    return validateRegexMatch(message, value, regex);
};


const standardTextRegexErrorMessage = (value : any) => `Die Eingabe enthält ungültige Zeichen. Erlaubt sind: ${textRegexString} oder die leere Eingabe.`;
const validateShort = validateShortTextField(standardTextRegexErrorMessage);
const validateMedium = validateMediumTextField(standardTextRegexErrorMessage);
const validateLong = validateLongTextField(standardTextRegexErrorMessage);

const standardIntegerRegexErrorMessage = (value : any) => `Die Eingabe enthält ungültige Zeichen. Erlaubt sind nur ganze Zahlen, z.B. 13 oder die leere Eingabe.`;
const validateNumber = validateNumberTextField(standardIntegerRegexErrorMessage);

const validateGermanZip = validateGermanZipTextField("Die eingabe ist keine gültige deutsche Postleitzahl. Gültige Eingaben sind 5stellige ganze Zahlen oder die leere Eingabe.");

const standardURLRegexErrorMessage = (value : any) => `Die Eingabe enthält ungültige Zeichen für eine URL. Die URL kann auch leer bleiben.`;
const validateUrl = validateURLField(standardURLRegexErrorMessage);

const standardCategoryRegexErrorMessage = (value : any) => `Die Eingabe enthält ungültige Zeichen. Nur die zwei Werte Ja oder Nein sind erlaubt.`;
const validateforProfit = validateforProfitField(standardCategoryRegexErrorMessage);

const validateState = validateStateField(standardCategoryRegexErrorMessage);

export {validateShort, validateMedium, validateLong, validateUrl, validateforProfit, validateState, validateNumber, validateGermanZip};

export function createProjectLinkUrl({uid, pid}: { uid: string, pid: jotoTypes.ValidPidValues }) {
    return `/projects.html?${queryString.stringify({uid, pid})}`;
}

export function createProjectMainPageLinkUrl({uid, pid}: { uid: string, pid: jotoTypes.ValidPidValues }) {
    return `/index.html?${queryString.stringify({uid, pid})}`;
}

export function createPermLinkUrl({uid, pid}: { uid: string, pid: jotoTypes.ValidPidValues }) {
    return `${env.project_base_url}/projects/${uid}/${pid}`;
}


export function generateDummyPicture(txt : string, width=287, height=180) {
    let url = '';
    if(txt.length > 0) {
        url = `https://dummyimage.com/${width}x${height}/233443/fff.jpg&text=${txt.trim()[0]}`;

    } else {
        url = `https://dummyimage.com/${width}x${height}/233443/fff.jpg`;
    }
    return url;
}

// define project property mapping objects

export interface ProjectProperty {
    label: string,
    value: string
}
export const profitOptions : ProjectProperty[] = [
    {
        label: "Ja",
        value: "yes"
    },
    {
        label: "Nein",
        value: "no"
    },
];

export const projectStateOptions : ProjectProperty[] = [
    {
        label: "1-Idee",
        value: "1"
    },
    {
        label: "2-Planung",
        value: "2"
    },
    {
        label: "3-Durchführung",
        value: "3",
    }
];


//export const mapProfitOptions: ProfitOption[] = {
//}
